import React, { useEffect, useState } from 'react'
import {
  Input,
  Select,
  Button,
  Space,
  Card,
  message,
  Popconfirm,
  DatePicker,
} from 'antd'
import styles from './PointsRechargeOrderList.module.css'

import { Pagination } from 'antd'

import {
  getInfoListRequest,
  getRegionListRequest,
  getSchoolTypeListRequest,
} from './api.js'
import {
  closeAdminPage,
  openLogin,
} from '../../../store/modalsSlice.js'
import settingIcon from './setting.svg'
import { useDispatch } from 'react-redux'
import InfoItem from './InfoItem.jsx'
import { clearAllCookies } from '../../../util/handleObject.js'
import dayjs from 'dayjs'
import ExcelUtil from "../../../util/excelUtilNew.js";
import { getMoneyDate } from '../../../util/currencyUnit.js'

const { RangePicker } = DatePicker

const PointsRechargeOrderList = () => {
  const dispatch = useDispatch()
  // 筛选表单状态
  const [filterForm, setFilterForm] = useState({
    name: '',
    payType: {
      value: '',
      label: '未选择',
    },
    accountType: {
      value: '',
      label: '未选择',
    },
    optime: ['', ''], //支付时间
    province: {
      value: '',
      label: '未选择',
    },
    municipality: {
      value: '',
      label: '未选择',
    },
    county: {
      value: '',
      label: '未选择',
    },
  })
  const [payTypeList, setPayTypeList] = useState([{
    value: '',
    label: '未选择',
  },{
    value: '1',
    label: '微信',
  },{
    value: '2',
    label: '支付宝',
  }])
  const [accountTypeList, setAccountTypeList] = useState([{
    value: '',
    label: '未选择',
  },{
    value: '1',
    label: '普通用户',
  },{
    value: '3',
    label: '教师用户',
  }])
  const [provinceList, setProvinceList] = useState([])
  const [municipalityList, setMunicipalityList] = useState([])
  const [countyList, setCountyList] = useState([])
  const [dataList, setDataList] = useState([])
  // 分页状态
  const [totalNumber, setTotalNumber] = useState(0)
  const [total_jiaofei, setTotal_jiaofei] = useState(0)
  const [limit, setLimit] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [schoolTypeList, setSchoolTypeList] = useState([])
  const [rangeTime, setRangeTime] = useState(['', ''])
  const [messageApi, contextHolder] = message.useMessage()

  useEffect(() => {
    getRegionList('1', '')
    getOrderList(
      (currentPage - 1) * limit,
      limit,
    )
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function getRegionList(regionCode, parentCode) {
    getRegionListRequest(regionCode, parentCode, (data) => {
      var newRegionList = [
        {
          quyu_name: '未选择',
          quyu_code: '',
        },
      ]
      if (data.ret == 1) {
        data.data.forEach((element) => {
          newRegionList.push(element)
        })
      } else if (data.ret == 99) {
        messageApi.open({
          type: 'warning',
          content: data.msg,
        })
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      }
      if (regionCode == 1) {
        setProvinceList(newRegionList)
      } else if (regionCode == 2) {
        setMunicipalityList(newRegionList)
      } else if (regionCode == 3) {
        setCountyList(newRegionList)
      }
    })
  }
  function getSchoolTypeList() {
    getSchoolTypeListRequest((data) => {
      var newSchoolTypeList = [
        {
          type_name: '全部',
          type_code: '',
        },
      ]
      if (data.ret == 1) {
        data.data.forEach((element) => {
          newSchoolTypeList.push(element)
        })
      } else {
        message.warning(data.msg)
      }
      setSchoolTypeList(newSchoolTypeList)
      console.log(schoolTypeList)
    })
  }

  function getOrderList(
    offset,
    limit,
  ) {
    
    getInfoListRequest(
      filterForm.name,
      filterForm.payType.value,
      filterForm.accountType.value,
      rangeTime[0],
      rangeTime[1],
      filterForm.province.value,
      filterForm.municipality.value,
      filterForm.county.value,
      offset,
      limit,
      (data) => {
        console.log(data)
        if (data.ret === '1') {
          setDataList(data.data.data)
          setTotalNumber(data.data.total_num)
          setTotal_jiaofei(data.data.total_jiaofei)
        } else {
          setDataList([])
          setTotalNumber(0)
          setTotal_jiaofei(0)
        }
      },
    )
  }

  function updateData() {
    getOrderList(
      (currentPage - 1) * limit,
      limit,
    )
  }

  // 处理筛选表单变化
  const handleFilterChange = (name, value) => {
    console.log('------------')
    console.log(value)
    if (name == 'province') {
      setFilterForm({
      ...filterForm,
      ["municipality"]: {
        value: '',
        label: '未选择',
      },
      ["county"]: {
        value: '',
        label: '未选择',
      },
      [name]: value,
    })
    }
    else if (name == 'municipality') {
      setFilterForm({
      ...filterForm,
      ["county"]: {
        value: '',
        label: '未选择',
      },
      [name]: value,
    })
    }
    else {
      setFilterForm({
        ...filterForm,
        [name]: value,
      })
    }
  }

  // 处理筛选提交
  const handleFilterSubmit = () => {
    setCurrentPage(1)
    getOrderList(
      0,
      limit,
    )
  }

  // 处理重置筛选
  const handleResetFilter = () => {
    setRangeTime(['', ''])
    setMunicipalityList([])
    setCountyList([])
    setFilterForm({
      name: '',
      payType: {
        value: '',
        label: '未选择',
      },
      accountType: {
        value: '',
        label: '未选择',
      },
      optime: ['', ''], //支付时间
      province: {
        value: '',
        label: '未选择',
      },
      municipality: {
        value: '',
        label: '未选择',
      },
      county: {
        value: '',
        label: '未选择',
      },
    })
    setCurrentPage(1)
    // 重置后重新获取所有数据
  }

  const onShowSizeChange = (page, pageSize) => {
    //pageSize 变化的回调
    console.log(page, pageSize)
    setCurrentPage(1)
    setLimit(pageSize)
  }

  const onChangePage = (current, pageSize) => {
    //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
    setCurrentPage(current)
    getOrderList(
      (current - 1) * pageSize,
      pageSize,
    )
  }

  function exportExcelMethod() {
        if (dataList.length == 0) {
            message.warning('暂无内容导出')
            return;
        }
        let attendanceBKInfoList = [];
        dataList.map((item, index) => {
            attendanceBKInfoList.push({
                '订单编号': item.transaction_id,
                '支付渠道': item.pay_type == 1 ? "微信" : "支付宝",
                '省级区域': item.shengfen_name,
                '市级区域': item.shi_name,
                '区县区域': item.quxian_name,
                '交易金额': getMoneyDate("fen",item.dingdan_amount),
                '账户类型': item.user_type == 0 ? "普通账户" : "教师账户",
                '所在学校': item.school_name,
                '充值账号':item.user_login,
                '用户名': item.name,
                '充值时间': item.jiaofei_time,
            })
        })
        ExcelUtil.exportExcel( attendanceBKInfoList, `订单表.xlsx`,
            [
                {wpx: 224},
                {wpx: 160},
                {wpx: 150},
                {wpx: 136},
                {wpx: 90},
                {wpx: 114},
                {wpx: 176}
            ]
        )
    }

  const dateFormat = 'YYYY-MM-DD HH:mm'
  // const dateFormat = 'YYYY-MM-DD'
  const today = new Date()
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  const formatter = new Intl.DateTimeFormat('zh-CN', options)

  var maxDateString = formatter.format(today).replaceAll('/', '-') + ' 23:59'
  return (
    <div className={styles.background}>
      {contextHolder}
      <div className={styles.rightMenus}>
        <div className={styles['div-top']}>
          <h3 style={{ marginLeft: 30 }}>线上订单管理</h3>

          <Popconfirm
            placement="bottom"
            title={''}
            description={'是否退出登录'}
            okText="是"
            cancelText="否"
            onConfirm={(e) => {
              sessionStorage.clear()
              clearAllCookies()
              dispatch(closeAdminPage())
              dispatch(openLogin())
            }}
          >
            <div className={styles.iconContainer}>
              <img
                src={settingIcon}
                style={{ width: '20px', height: '20px' }}
              />
            </div>
          </Popconfirm>

          <Button
            className={styles['bt-refresh']}
            type="primary"
            onClick={(e) => {
              getOrderList(
                (currentPage - 1) * limit,
                limit,
              )
            }}
          >
            刷新
          </Button>
        </div>

        <Card
          title=""
          className={styles['card-top']}
          actions={[
            <div>
              <Space>
                <Button onClick={handleResetFilter}>重置</Button>
                <Button color="primary" variant="outlined" onClick={exportExcelMethod}>
                  导出
                </Button>
                <Button type="primary" onClick={handleFilterSubmit}>
                  查询
                </Button>
              </Space>
            </div>,
          ]}
        >
          <div className={styles['div-shaixuan']}>
            <div>数据筛选</div>
          </div>
          <table>
            <tr>
              <td className={styles.dataFilterTd}>关键字</td>
              <td className={styles.dataFilterTd1}>
                <Input
                  placeholder="订单编号、充值账号"
                  value={filterForm.name}
                  onChange={(e) => handleFilterChange('name', e.target.value)}
                />
              </td>
              <td className={styles.dataFilterTd}>支付渠道</td>
              <td className={styles.dataFilterTd1}>
                <Select
                  defaultValue={'全部'}
                  value={filterForm.payType.label}
                  style={{ width: '116px' }}
                  // onChange={(value, label) => handleFilterChange('payType', {
                  //   value: value,
                  //   label: label,
                  // })}
                  onChange={(value, label) => {
                    handleFilterChange('payType', {
                      value: value,
                      label: label,
                    })
                  }}
                  options={payTypeList.map((item) => {
                    return {
                      value: item.value,
                      label: item.label,
                    }
                  })}
                ></Select>
              </td>
              <td className={styles.dataFilterTd}>账户类型</td>
              <td className={styles.dataFilterTd1}>
                <Select
                  defaultValue={'未选择'}
                  value={filterForm.accountType.label}
                  popupMatchSelectWidth={true}
                  style={{minWidth:90}}
                  onChange={(value, label) => {
                    handleFilterChange('accountType', {
                      value: value,
                      label: label,
                    })
                  }}
                  options={accountTypeList.map((item) => {
                    return {
                      value: item.value,
                      label: item.label,
                    }
                  })}
                ></Select>
              </td>
              <td className={styles.dataFilterTd}>省级区域</td>
              <td className={styles.dataFilterTd1}>
                <Select
                  defaultValue={'未选择'}
                  value={filterForm.province.label}
                  onChange={(value, label) => {
                    handleFilterChange('province', {
                      value: value,
                      label: label,
                    })
                    getRegionList('2', value)
                    setMunicipalityList([])
                    setCountyList([])
                  }}
                  options={provinceList.map((item) => {
                    return {
                      value: item.quyu_code,
                      label: item.quyu_name,
                    }
                  })}
                ></Select>
              </td>
              <td className={styles.dataFilterTd}>&nbsp;&nbsp;&nbsp;&nbsp;</td>
              {/* <td className={styles.dataFilterTd}>&nbsp;&nbsp;&nbsp;&nbsp;</td> */}
              {/* <td className={styles.dataFilterTd}>&nbsp;&nbsp;&nbsp;&nbsp;</td> */}
              {/* <td className={styles.dataFilterTd}>&nbsp;&nbsp;&nbsp;&nbsp;</td> */}
            </tr>
            <tr>
              <td className={styles.dataFilterTd}>市级区域</td>
              <td className={styles.dataFilterTd1}>
                <Select
                  defaultValue={'未选择'}
                  value={filterForm.municipality.label}
                  onChange={(value, label) => {
                    handleFilterChange('municipality', {
                      value: value,
                      label: label,
                    })
                    getRegionList('3', value)
                    setCountyList([])
                  }}
                  options={municipalityList.map((item) => {
                    return {
                      value: item.quyu_code,
                      label: item.quyu_name,
                    }
                  })}
                ></Select>
              </td>
              <td className={styles.dataFilterTd}>区县区域</td>
              <td className={styles.dataFilterTd1}>
                <Select
                  defaultValue={'未选择'}
                  value={filterForm.county.label}
                  onChange={(value, label) => {
                    handleFilterChange('county', {
                      value: value,
                      label: label,
                    })
                  }}
                  options={countyList.map((item) => {
                    return {
                      value: item.quyu_code,
                      label: item.quyu_name,
                    }
                  })}
                ></Select>
              </td>
              <td className={styles.dataFilterTd}>支付时间</td>
              <td className={styles.dataFilterTd1} colSpan={7}>
                <RangePicker
                  // locale={locale}
                  // needConfirm = {true}
                  // minDate={dayjs('2024-01-01', dateFormat)}
                  minDate={dayjs('2024-01-01 00:00', dateFormat)}
                  maxDate={dayjs(maxDateString, dateFormat)}
                  showTime={{ format: 'HH:mm' }}

                  // minDate={dayjs('2024-01-01', dateFormat)}
                  // maxDate={dayjs(maxDateString, dateFormat)}
                  value={
                    rangeTime[0].length > 0
                      ? [
                          dayjs(rangeTime[0], dateFormat),
                          dayjs(rangeTime[1], dateFormat),
                        ]
                      : null
                  }
                  onChange={(date, dateString) => {
                    setRangeTime(dateString)
                  }}
                />
              </td>
            </tr>
          </table>
        </Card>

        <Card title="" className={styles['card-bottom']}>
          <div className={styles['container-list']}>
            <div className={styles['div-shaixuan']}>
              <div>数据列表</div>
            </div>

            <div className={styles.tableContainer}>
              <table className={styles.infoTable}>
                <tr className={styles.tr1}>
                  <td className={styles.td1}>订单编号</td>
                  <td className={styles.td2}>支付渠道</td>
                  <td className={styles.td2}>省级区域</td>
                  <td className={styles.td2}>市级区域</td>
                  <td className={styles.td2}>区县区域</td>
                  <td className={styles.td2}>交易金额</td>
                  <td className={styles.td2}>账号类型</td>
                  <td className={styles.td2}>所在学校</td>
                  <td className={styles.td2}>充值账号</td>
                  <td className={styles.td2}>用户名</td>
                  <td className={styles.td2}>支付时间</td>
                </tr>
                {dataList.map((item, index) => (
                  <InfoItem item={item} key={index + 1} index={index + 1} />
                ))}
              </table>

              {/* 分页控件 - 右下角 */}
              {/* <div style={{marginTop:10}}>{`订单数量 ${totalNumber}\t  交易金额 ${getMoneyDate("fen",total_jiaofei)}`}</div> */}
            </div>
            <div style={{display: "flex", alignItems:"center", justifyContent: "space-between"}}>
                <div style={{display: "flex", alignItems:"center"}}>
                    <h3>订单数量:{totalNumber}</h3>
                    <h3 style={{marginLeft:20}}>交易金额:{getMoneyDate("fen",total_jiaofei)}</h3>
                </div>
                <Pagination
                  hideOnSinglePage={false} //只有一页隐藏分页器
                  align="end"
                  style={{ marginTop: 20 }}
                  showSizeChanger //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
                  onShowSizeChange={onShowSizeChange} //pageSize 变化的回调
                  defaultCurrent={1}
                  current={currentPage}
                  total={totalNumber}
                  locale={{
                    items_per_page: '条/页', // 将 "/page" 改为 "/页"
                  }}
                  pageSizeOptions={['10', '20', '30']} // 自定义选项值
                  pageSize={limit}
                  onChange={onChangePage}
                  showLessItems={false} // 关闭"简化显示"模式
                />
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default PointsRechargeOrderList
